import React from 'react';
import { Check, Shield, ArrowRight, BookOpen, Heart, Award, Calendar } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CTAButton } from './CTAButton';
import { SocialProofPopup } from './SocialProofPopup';
import { BonusCard } from './BonusCard';
import { TestimonialCard } from './TestimonialCard';
import { BeforeAfter } from './BeforeAfter';
export function SalesPage() {
  const checkoutUrl = 'https://checkout.solucionstore.shop/cart/45164104384703:1';
  const bonuses = [{
    title: 'Dulces para Momentos Especiales',
    description: 'Tortas, frascos y opciones para regalar o vender.',
    imageSrc: 'https://cdn.magicpatterns.com/uploads/uBXgTLees7CagxWYYgx2Y9/ChatGPT_Image_10_feb_2026,_11_18_52_a.m..png',
    number: 1
  }, {
    title: 'Guía Maestra de Sustituciones',
    description: 'Nunca más frenar una receta por falta de ingredientes.',
    imageSrc: 'https://cdn.magicpatterns.com/uploads/qNYVwNksjeKPUCC7YXMgcE/ChatGPT_Image_10_feb_2026,_10_37_37_a.m..png',
    number: 2
  }, {
    title: 'Budines que Abrazan',
    description: 'Húmedos, tiernos y rendidores.',
    imageSrc: 'https://cdn.magicpatterns.com/uploads/oo6P2EbJLk84wFhUxt231R/ChatGPT_Image_10_feb_2026,_11_04_36_a.m..png',
    number: 3
  }, {
    title: 'Facturas & Croissant Sin Drama',
    description: 'Laminado simplificado con resultados reales.',
    imageSrc: 'https://cdn.magicpatterns.com/uploads/4FzH1dH1rY6W8a13FGf6Pp/ChatGPT_Image_10_feb_2026,_11_12_14_a.m..png',
    number: 4
  }, {
    title: 'Panettone & Pan Dulce Italiano',
    description: 'Versión saludable sin resignar sabor.',
    imageSrc: 'https://cdn.magicpatterns.com/uploads/g1yvDXp7NvpDrNh1jZ3CD5/ChatGPT_Image_10_feb_2026,_12_43_30_p.m..png',
    number: 5
  }, {
    title: 'Harinas Artesanales Sin Gluten',
    description: 'Creá tus propias mezclas y ahorrá dinero.',
    imageSrc: 'https://cdn.magicpatterns.com/uploads/taYL4RCBDGtrAr3EbtiiQk/ChatGPT_Image_10_feb_2026,_01_45_35_p.m..png',
    number: 6
  }, {
    title: 'Cocina Segura & Freezer en Paz',
    description: 'Organización inteligente y conservación correcta.',
    imageSrc: 'https://cdn.magicpatterns.com/uploads/iXhxr4fBtMsTC34rEvHfiZ/ChatGPT_Image_10_feb_2026,_01_56_28_p.m..png',
    number: 7
  }];
  return <div className="font-sans text-gray-900 bg-white min-h-screen pb-20" data-id="element-51">
      <CountdownTimer data-id="element-52" />
      <SocialProofPopup data-id="element-53" />

      {/* Hero Section */}
      <header className="max-w-4xl mx-auto px-4 pt-8 pb-12 text-center" data-id="element-54">
        <p className="text-lg md:text-xl font-medium text-gray-600 mb-4" data-id="element-55">
          👩‍🍳 Para personas que quieren hornear saludable sin ser expertas
        </p>

        <h1 className="text-4xl md:text-6xl font-black text-gray-900 leading-tight mb-2" data-id="element-56">
          🥖 MegaPack Cocina que Sana
        </h1>
        <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-57">
          Panes y Dulces Sin Renunciar al Placer
        </h2>

        <div className="inline-block bg-green-100 text-green-800 font-bold px-4 py-2 rounded-full mb-8 text-sm md:text-base border border-green-200" data-id="element-58">
          Sin gluten · Sin azúcar · Sin lactosa
        </div>

        <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block mb-8 hover:opacity-95 transition-opacity" data-id="element-59">
          <img src="https://cdn.magicpatterns.com/uploads/15v1V52n9iJE2c74bPTJbo/ChatGPT_Image_11_feb_2026,_10_36_09_p.m..png" alt="MegaPack Cocina que Sana" className="w-full max-w-2xl mx-auto rounded-xl shadow-2xl" data-id="element-60" />
        </a>

        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-8 text-left max-w-2xl mx-auto" data-id="element-61">
          <p className="text-lg font-bold text-gray-800 flex items-center gap-2" data-id="element-62">
            ✨ En 7 días vas a poder hornear y ofrecer tus primeras ventas.
          </p>
        </div>

        <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-63">
          Todo lo que necesitás para hornear con estructura, evitar
          frustraciones y no volver a sentir que "la panadería saludable no
          funciona". Claro. Práctico. Con método. Sin improvisar.
        </p>

        <CTAButton text="👉 SÍ, QUIERO EMPEZAR AHORA" data-id="element-64" />

        <div className="flex items-center justify-center gap-2 mt-4 text-gray-500 text-sm font-medium" data-id="element-65">
          <Shield className="w-4 h-4" data-id="element-66" />✅ Garantía de satisfacción
        </div>
      </header>

      {/* Pain Points Section */}
      <section className="bg-gray-50 py-16 px-4" data-id="element-67">
        <div className="max-w-3xl mx-auto" data-id="element-68">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-69">
            Si te gusta cocinar, dejame hacerte una pregunta honesta…
          </h3>

          <div className="space-y-6 text-lg text-gray-700 mb-12" data-id="element-70">
            <p data-id="element-71">¿Te pasó que intentaste hacer pan sin gluten… y quedó seco?</p>
            <p data-id="element-72">¿Un budín sin azúcar… y se desarmó?</p>
            <p data-id="element-73">
              ¿Gastaste en premezclas caras… y el resultado no fue el mismo?
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 mb-12" data-id="element-74">
            <p className="font-bold text-xl text-gray-900 mb-4" data-id="element-75">
              No es falta de capacidad. No es que "no seas buena para cocinar".
            </p>
            <p className="text-gray-700 mb-4" data-id="element-76">
              Es que nadie te enseñó la estructura correcta.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-77">
              Vas con ilusión… Seguís una receta… Esperás que salga perfecto…
            </p>
            <p className="text-gray-700 italic border-l-4 border-red-400 pl-4 py-1 bg-red-50" data-id="element-78">
              Y cuando no funciona, pensás: "Ojalá supiera qué estoy haciendo
              mal…"
            </p>
          </div>

          <h3 className="text-3xl font-black text-center mb-8" data-id="element-79">
            Cocinar saludable no debería sentirse así
          </h3>

          <p className="text-center text-xl mb-8" data-id="element-80">
            El problema que nadie dice en voz alta es este:
          </p>

          <div className="bg-red-600 text-white p-6 rounded-lg text-center font-bold text-xl mb-12 shadow-lg mx-auto max-w-2xl" data-id="element-81">
            👉 No fallás por los ingredientes. Fallás por no entender la
            estructura.
          </div>

          <p className="font-bold text-gray-800 mb-6" data-id="element-82">
            Si te gusta hornear, esto seguro te resulta familiar:
          </p>

          <ul className="space-y-3 mb-8" data-id="element-83">
            {['No sabés qué da humedad', 'No entendés cómo lograr elasticidad sin gluten', 'Cambiás ingredientes y la receta se arruina', 'No sabés cómo rescatar una masa', 'Tenés miedo de vender porque no sale igual siempre'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-84">
                <span className="w-2 h-2 bg-red-500 rounded-full flex-shrink-0" data-id="element-85"></span>
                <span className="text-gray-700" data-id="element-86">{item}</span>
              </li>)}
          </ul>

          <p className="text-xl font-bold text-center text-gray-900" data-id="element-87">
            Lo peor no es que no salga perfecto. Es la frustración constante.
          </p>
        </div>
      </section>

      {/* Solution Section - Black Background */}
      <section className="bg-gray-900 text-white py-20 px-4" data-id="element-88">
        <div className="max-w-4xl mx-auto text-center" data-id="element-89">
          <h2 className="text-3xl md:text-5xl font-black text-yellow-400 mb-6" data-id="element-90">
            ✅ LA SOLUCIÓN
          </h2>
          <h3 className="text-2xl md:text-4xl font-bold mb-8" data-id="element-91">
            MegaPack Cocina que Sana
          </h3>

          <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto" data-id="element-92">
            Un sistema completo, paso a paso, diseñado para que puedas hornear
            panes y dulces saludables con estructura real, sin frustración y con
            resultados repetibles.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-93">
            <div className="bg-gray-800 p-6 rounded-xl border border-gray-700" data-id="element-94">
              <div className="text-4xl mb-4" data-id="element-95">📘</div>
              <h4 className="font-bold text-xl mb-2" data-id="element-96">Abrís el método</h4>
            </div>
            <div className="bg-gray-800 p-6 rounded-xl border border-gray-700" data-id="element-97">
              <div className="text-4xl mb-4" data-id="element-98">🍞</div>
              <h4 className="font-bold text-xl mb-2" data-id="element-99">Entendés la base</h4>
            </div>
            <div className="bg-gray-800 p-6 rounded-xl border border-gray-700" data-id="element-100">
              <div className="text-4xl mb-4" data-id="element-101">✨</div>
              <h4 className="font-bold text-xl mb-2" data-id="element-102">Aplicás con seguridad</h4>
            </div>
          </div>

          <p className="text-xl font-medium text-yellow-200" data-id="element-103">
            Sin adivinar. Sin depender de premezclas. Sin caos.
          </p>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-16 px-4 max-w-4xl mx-auto" data-id="element-104">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-105">
          📦 ¿Qué incluye exactamente el MegaPack?
        </h2>

        <div className="bg-blue-50 p-8 rounded-2xl border-2 border-blue-100 mb-12" data-id="element-106">
          <h3 className="text-2xl font-bold text-blue-900 mb-4 flex items-center gap-3" data-id="element-107">
            <BookOpen className="w-8 h-8" data-id="element-108" />
            Programa Principal – Cocina que Sana
          </h3>
          <p className="text-blue-800 mb-6 font-medium" data-id="element-109">
            Bases estructurales, recetas estrella, rescates rápidos y plan de
            acción 7 días.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-110">
            {['Qué da humedad', 'Qué da elasticidad', 'Qué da estructura', 'Cómo rescatar una preparación', 'Cómo organizar tu producción'].map((item, i) => <div key={i} className="flex items-center gap-2 bg-white p-3 rounded-lg shadow-sm" data-id="element-111">
                <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-112" />
                <span className="text-gray-700 font-medium" data-id="element-113">{item}</span>
              </div>)}
          </div>
        </div>

        <div className="mb-16" data-id="element-114">
          <CTAButton text="🔥 ¡QUIERO MI MEGAPACK AHORA!" data-id="element-115" />
        </div>

        {/* Bonuses */}
        <div className="mb-16" data-id="element-116">
          <div className="text-center mb-12" data-id="element-117">
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-118">
              🎁 BONOS ESPECIALES
            </h2>
            <span className="inline-block bg-red-600 text-white font-bold px-6 py-2 rounded-full text-xl animate-bounce" data-id="element-119">
              GRATIS HOY
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-120">
            {bonuses.map((bonus, index) => <BonusCard key={index} {...bonus} data-id="element-121" />)}
          </div>
        </div>
      </section>

      {/* 7 Day Plan */}
      <section className="bg-gray-50 py-16 px-4" data-id="element-122">
        <div className="max-w-4xl mx-auto" data-id="element-123">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12 flex items-center justify-center gap-3" data-id="element-124">
            <Calendar className="w-8 h-8 text-blue-600" data-id="element-125" />
            🗓️ En solo 7 días podés lograr esto:
          </h2>

          <div className="space-y-4 max-w-2xl mx-auto mb-12" data-id="element-126">
            {[{
            day: 1,
            text: 'Preparás tu base infalible'
          }, {
            day: 2,
            text: 'Horneás tu primer pan exitoso'
          }, {
            day: 3,
            text: 'Hacés tu budín estrella'
          }, {
            day: 4,
            text: 'Organizás tu freezer'
          }, {
            day: 5,
            text: 'Probás producción simple'
          }, {
            day: 6,
            text: 'Definís 3 productos vendibles'
          }, {
            day: 7,
            text: 'Podés ofrecer tu primera mini línea'
          }].map((item, i) => <div key={i} className="flex items-center gap-4 bg-white p-4 rounded-lg shadow-sm border-l-4 border-blue-500 hover:scale-105 transition-transform" data-id="element-127">
                <span className="font-black text-blue-600 text-xl w-16" data-id="element-128">
                  Día {item.day}:
                </span>
                <span className="font-medium text-gray-800 text-lg" data-id="element-129">
                  {item.text}
                </span>
              </div>)}
          </div>

          <p className="text-center text-xl font-bold text-gray-600 mb-16" data-id="element-130">
            Sin perfección. Sin estrés. Sin gastar de más.
          </p>

          {/* Before/After */}
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-131">
            🔄 Antes vs Después
          </h2>
          <BeforeAfter data-id="element-132" />
        </div>
      </section>

      {/* Who is it for */}
      <section className="py-16 px-4 max-w-5xl mx-auto" data-id="element-133">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-134">
          <div data-id="element-135">
            <h3 className="text-2xl font-black text-green-700 mb-6 flex items-center gap-2" data-id="element-136">
              <Check className="w-8 h-8" data-id="element-137" />
              💬 ¿Para quién es?
            </h3>
            <ul className="space-y-4" data-id="element-138">
              {['Mamás que quieren meriendas reales', 'Personas recién diagnosticadas celíacas', 'Quienes buscan reducir azúcar sin resignar placer', 'Emprendedoras que quieren vender desde casa', 'Personas que quieren orden y tranquilidad en la cocina'].map((item, i) => <li key={i} className="flex items-start gap-3 bg-green-50 p-3 rounded-lg" data-id="element-139">
                  <Check className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" data-id="element-140" />
                  <span className="text-gray-800 font-medium" data-id="element-141">{item}</span>
                </li>)}
            </ul>
          </div>

          <div data-id="element-142">
            <h3 className="text-2xl font-black text-red-700 mb-6 flex items-center gap-2" data-id="element-143">
              <XCircle className="w-8 h-8" data-id="element-144" />
              🚫 ¿Para quién NO es?
            </h3>
            <ul className="space-y-4" data-id="element-145">
              {['Para quien busca resultados sin practicar', 'Para quien no quiere seguir un método', 'Para quien abandona a la primera dificultad'].map((item, i) => <li key={i} className="flex items-start gap-3 bg-red-50 p-3 rounded-lg" data-id="element-146">
                  <XCircle className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" data-id="element-147" />
                  <span className="text-gray-800 font-medium" data-id="element-148">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="bg-gray-50 py-16 px-4" data-id="element-149">
        <div className="max-w-6xl mx-auto" data-id="element-150">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-151">
            Lo que dicen quienes ya están horneando
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-152">
            <TestimonialCard name="María Fernanda" age={34} location="Buenos Aires" quote="Mis hijos ahora me piden mis galletitas en lugar de las compradas. El método es tan claro que hasta ellos me ayudan a cocinar." role="Mamá de 2" data-id="element-153" />
            <TestimonialCard name="Luciana" age={41} location="Córdoba" quote="Desde que me diagnosticaron celiaquía pensé que nunca más comería un pan rico. Este pack me devolvió el placer de comer sin culpa ni dolor." role="Recién diagnosticada" data-id="element-154" />
            <TestimonialCard name="Carolina" age={29} location="Rosario" quote="Empecé vendiendo a mis vecinas y ahora tengo pedidos fijos todos los fines de semana. La guía de costos me salvó la vida." role="Emprendedora" data-id="element-155" />
            <TestimonialCard name="Gabriela" age={47} location="Mendoza" quote="Bajar el azúcar era una necesidad médica, pero no quería dejar de disfrutar. Los budines son increíbles, nadie cree que son saludables." data-id="element-156" />
            <TestimonialCard name="Valentina" age={38} location="Mar del Plata" quote="Tiraba tanta comida antes... Ahora entiendo el por qué de cada ingrediente. Mis panes salen siempre perfectos." data-id="element-157" />
          </div>
        </div>
      </section>

      {/* Emotional Close */}
      <section className="py-16 px-4 max-w-3xl mx-auto text-center" data-id="element-158">
        <h2 className="text-3xl font-black text-yellow-500 mb-8" data-id="element-159">
          💛 Lo que realmente estás comprando
        </h2>

        <div className="text-xl text-gray-700 space-y-6 mb-12" data-id="element-160">
          <p data-id="element-161">No son recetas.</p>
          <p className="font-bold text-2xl text-gray-900" data-id="element-162">
            Es estructura. Es método. Es confianza.
          </p>
          <p data-id="element-163">Es abrir el horno y sentir orgullo.</p>
          <p data-id="element-164">
            Es decir: <span className="italic" data-id="element-165">"Esto lo hice yo."</span>
          </p>
          <p data-id="element-166">
            Y si querés…{' '}
            <span className="italic font-bold text-green-600" data-id="element-167">
              "Esto lo vendí yo."
            </span>
          </p>
        </div>
      </section>

      {/* Stack Offer */}
      <section className="bg-gray-900 text-white py-16 px-4" data-id="element-168">
        <div className="max-w-4xl mx-auto border-4 border-yellow-500 rounded-2xl p-6 md:p-12 bg-gray-800 relative overflow-hidden" data-id="element-169">
          <div className="absolute top-0 right-0 bg-yellow-500 text-black font-bold px-8 py-2 transform rotate-45 translate-x-8 translate-y-4 shadow-lg" data-id="element-170">
            OFERTA ESPECIAL
          </div>

          <h2 className="text-3xl md:text-5xl font-black text-center mb-12" data-id="element-171">
            🟢 Lo que recibís hoy
          </h2>

          <div className="space-y-4 mb-12 text-lg md:text-xl" data-id="element-172">
            <div className="flex items-center gap-3 border-b border-gray-700 pb-3" data-id="element-173">
              <Check className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-174" />
              <span className="font-bold" data-id="element-175">
                Programa completo Cocina que Sana
              </span>
            </div>
            <div className="flex items-center gap-3 border-b border-gray-700 pb-3" data-id="element-176">
              <Check className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-177" />
              <span className="font-bold" data-id="element-178">7 Bonos exclusivos</span>
            </div>
            <div className="flex items-center gap-3 border-b border-gray-700 pb-3" data-id="element-179">
              <Check className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-180" />
              <span className="font-bold" data-id="element-181">Plan de acción 7 días</span>
            </div>
            <div className="flex items-center gap-3 border-b border-gray-700 pb-3" data-id="element-182">
              <Check className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-183" />
              <span data-id="element-184">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-3 border-b border-gray-700 pb-3" data-id="element-185">
              <Check className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-186" />
              <span data-id="element-187">Descarga digital</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-188">
              <Check className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-189" />
              <span className="font-bold text-yellow-400" data-id="element-190">
                Acceso de por vida
              </span>
            </div>
          </div>

          <CTAButton text="👉 QUIERO EMPEZAR A COCINAR AHORA" data-id="element-191" />
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-16 px-4 bg-white" data-id="element-192">
        <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-8 border-2 border-gray-100 p-8 rounded-2xl shadow-lg" data-id="element-193">
          <div className="w-32 h-32 flex-shrink-0 bg-yellow-100 rounded-full flex items-center justify-center" data-id="element-194">
            <Award className="w-16 h-16 text-yellow-600" data-id="element-195" />
          </div>
          <div data-id="element-196">
            <h3 className="text-2xl font-black text-gray-900 mb-4" data-id="element-197">
              🔐 Garantía simple
            </h3>
            <p className="text-gray-700 text-lg" data-id="element-198">
              Si empezás y sentís que no es para vos, tenés garantía de
              satisfacción. Sin riesgo.
            </p>
          </div>
        </div>
      </section>

      {/* Visualization */}
      <section className="py-16 px-4 bg-green-50 text-center" data-id="element-199">
        <div className="max-w-3xl mx-auto" data-id="element-200">
          <h2 className="text-3xl font-black text-green-800 mb-8 flex items-center justify-center gap-3" data-id="element-201">
            <Heart className="w-8 h-8" data-id="element-202" />
            🌿 Imaginá esto…
          </h2>

          <p className="text-xl text-gray-800 mb-8 leading-relaxed" data-id="element-203">
            Tu cocina ordenada. Pan recién salido del horno. Budines listos para
            la semana. Pedidos confirmados para el sábado.
          </p>

          <p className="text-2xl font-bold text-gray-900 mb-12" data-id="element-204">
            No es suerte. Es método.
          </p>

          <CTAButton text="👉 QUIERO EMPEZAR A COCINAR AHORA" data-id="element-205" />
        </div>
      </section>

      <footer className="bg-gray-900 text-gray-500 py-12 text-center text-sm" data-id="element-206">
        <p data-id="element-207">© 2026 Cocina que Sana. Todos los derechos reservados.</p>
        <p className="mt-2" data-id="element-208">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}
// Helper component for the XCircle icon used in the main file but imported from lucide
function XCircle({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-209">
      <circle cx="12" cy="12" r="10" data-id="element-210" />
      <path d="m15 9-6 6" data-id="element-211" />
      <path d="m9 9 6 6" data-id="element-212" />
    </svg>;
}